import { Modal } from "@gravity-ui/uikit";

import { FiltersContent } from "../FiltersContent";

interface FiltersModalProps {
  open: boolean;
  onClose: () => void;
}

export const FiltersModal = ({ open, onClose }: FiltersModalProps) => {
  return (
    // disableOutsideClick: список категорий вынесен в портал (document.body) и
    // открывается сбоку от модалки — клик по нему считается «вне» модалки и иначе
    // закрывал бы её. Закрытие остаётся по крестику и Esc.
    <Modal open={open} onClose={onClose} disableOutsideClick>
      <FiltersContent isModal={true} onClose={onClose} />
    </Modal>
  );
};
